module.exports = __webpack_public_path__ + "static/media/GSOC.917c20d9.png";